module.exports = __webpack_public_path__ + "static/media/1010688.3a04b56e.jpg";